import http from './utils';
import { mockPrefix, prefix } from './constants';
import axios from 'axios';
const CancelToken = axios.CancelToken;

export const getCommunityVideoTimeLine: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/video/timeline`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const getCommunityVideoBatchTimeLine: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/video/batch_timeline`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const getCommunityVideoMaxMetric: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
  refreshTime?: number,
) => Promise<any> | any = (
  payload,
  cancelTokenFunc = (c: any) => {},
  refreshTime = 0,
) => {
  return http({
    url: `${prefix}/video/max_metric`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
    headers: refreshTime > 0 ? { user_cache_expire: refreshTime } : undefined,
  }) as Promise<any>;
};

export const getVideoTagInsight: (
  payload: any,
  cancelCallback?: any,
) => Promise<any> | any = (payload, cancelCallback = () => {}) => {
  return http({
    url: `${prefix}/video/tag_insight`,
    method: 'post',
    data: payload,
    cancelToken: new axios.CancelToken(cancelCallback),
    errorHandler: true,
  }) as Promise<any>;
};
